import React from 'react';

// This is the Hero section of the website, the first main section of texts under the header
// Called the Hero section because it's the main section of the website
// Asset folder with the images is in the "Hero Section Assets" folder
function Hero({ onOpenForm }) {
  return (
    <section className="relative overflow-hidden">
      {/* Main Hero Content */}
      <div 
        className="bg-primary-50 py-16 pb-24 relative"
        style={{
          backgroundImage: 'url("/assets/Hero Section Asset/Hero BG Test1.jpg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="absolute inset-0 bg-white bg-opacity-85"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-20">
          <div className="text-center">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              NAMHS & Partnership Healthplan
            </h2>
            <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
              Submit your patient referrals quickly and efficiently.
              <br />
              Our team will process your referral for your patient.
            </p>
          </div>

          <div className="mt-12 text-center">
            <div className="bg-white p-6 rounded-lg shadow-md max-w-2xl mx-auto">
              <h3 className="text-xl font-semibold text-primary-600 mb-4">For Partnership Healthplan</h3>
              <p className="text-gray-600 mb-6">
                Complete the referral form below to submit your patient for mental health services.
              </p>
              <div className="flex justify-center">
                <button
                  onClick={onOpenForm}
                  className="px-6 py-3 bg-primary-600 text-white rounded-md hover:bg-primary-700 font-medium transition-colors duration-200"
                >
                  Book an Appointment →
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom wave decoration - positioned absolute at bottom */}
        <div className="absolute bottom-0 left-0 w-full" style={{ transform: 'translateY(1px)' }}>
          {/* Orange wave layer */}
          <svg 
            className="w-full block absolute bottom-0"
            style={{ height: '100px', display: 'block' }}
            preserveAspectRatio="none"
            viewBox="0 0 1440 100"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="#ed9f62"
              fillOpacity="0.6"
              d="M0,60 C360,85 720,35 1080,60 C1260,70 1350,75 1440,80 L1440,100 L0,100 Z"
            />
          </svg>
          {/* White wave layer on top */}
          <svg 
            className="w-full block"
            style={{ height: '100px', display: 'block' }}
            preserveAspectRatio="none"
            viewBox="0 0 1440 100"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="#ffffff"
              d="M0,50 C360,90 720,10 1080,50 C1260,70 1350,80 1440,85 L1440,100 L0,100 Z"
            />
          </svg>
        </div>
      </div>
    </section>
  );
}

export default Hero; 